import type { RHCompany, RHContractingAuthorityType, RHProcurement } from "./prodModels.shim"


type RHContractingAuthorityDefinition = {
    title: string
    goodsAndServicesThreshold?: number
    worksThreshold?: number
}


export class RHContractingAuthorityRules {

    static readonly definitions: Readonly<Record<RHContractingAuthorityType, RHContractingAuthorityDefinition>> = {
        classical: {
            title: "Klassikalise sektori hankija",
            goodsAndServicesThreshold: 50_000,
            worksThreshold: 100_000
        },
        networkSector: {
            title: "Võrgustikusektori hankija",
            goodsAndServicesThreshold: 100_000,
            worksThreshold: 500_000
        },
        defenceAndSecurity: {
            title: "Kaitse- ja julgeolekuvaldkond",
            goodsAndServicesThreshold: 100_000,
            worksThreshold: 500_000
        },
        outsideRHS: {
            title: "RHS ei kohaldu"
        }
    }

    static readonly types = Object.keys(RHContractingAuthorityRules.definitions) as RHContractingAuthorityType[]

    static readonly thresholdNotice = "Piirmäärad alates 01.11.2026, ilma käibemaksuta."


    static thresholdForTypeAndCPV(authorityType: RHContractingAuthorityType, cpvCode: string): number | undefined {
        const definition = RHContractingAuthorityRules.definitions[authorityType]
        if (cpvCode.startsWith("45")) {
            return definition.worksThreshold
        }
        return definition.goodsAndServicesThreshold
    }


    static allowedTypesForCompany(
        company: Pick<RHCompany, "contractingAuthorityTypes">
    ): RHContractingAuthorityType[] {
        return [...(company.contractingAuthorityTypes ?? [])]
    }


    static typeForProcurementInCompany(
        procurement: Pick<RHProcurement, "contractingAuthorityType" | "isCompetition">,
        company: Pick<RHCompany, "contractingAuthorityTypes">
    ): RHContractingAuthorityType {
        if (procurement.contractingAuthorityType) {
            return procurement.contractingAuthorityType
        }
        if (procurement.isCompetition) {
            return "outsideRHS"
        }
        const companyTypes = RHContractingAuthorityRules.allowedTypesForCompany(company)
        if (companyTypes.length !== 1) {
            throw new Error("Hankija määratlust ei saa tuletada: ettevõttel peab olema täpselt üks lubatud määratlus.")
        }
        return companyTypes[0]
    }
}
